module.exports = __webpack_public_path__ + "assets/img/bg.f8db78ac.png";